import { useMutation, useQueryClient } from '@tanstack/react-query';

import { type ClassDetails } from '~entities/classes/modal/class';
import { invalidateSessionLinkedCounts } from '~entities/session/api/get-class-event-count-session-by-id';

import { baseAPI } from '~shared/api/base-api';

interface DeleteClassParams {
  classId: string;
}

export const deleteClassAPI = async (params: DeleteClassParams) => {
  const response = await baseAPI.delete<ClassDetails>(
    `/enrollments/${params.classId}`,
  );
  return response.data;
};

export const useDeleteClass = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: DeleteClassParams) => deleteClassAPI(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['classes'] });
      void invalidateSessionLinkedCounts(queryClient);
    },
  });
};
